import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import PageHeader from "./PageHeader";
import { PersonInfoInput } from "./PersonInfoInput";
import { update_people, post_paipan } from "../../client/paipan";

export default function EditPersonDialog({ open, person, user, onClose, onSaved }) {
  const [saving, setSaving] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  async function handleSubmit(personInfo) {
    if (!person || saving) return;
    setSaving(true);

    const payload = {
      name: personInfo.name,
      gender: personInfo.gender,
      birthday_str: personInfo.birthday_str,
      use_zaozi: personInfo.use_zaozi ? 1 : 0,
      use_true_solar: personInfo.use_true_solar ? 1 : 0,
      longitude: personInfo.longitude ?? null,
      birthplace: personInfo.birthplace,
    };

    if (user) {
      const updateRes = await update_people(person.id, payload);
      if (updateRes && updateRes.message === "更新成功") {
        const paipanRes = await post_paipan({ ...personInfo, update_id: person.id });
        if (paipanRes) {
          onSaved();
          onClose();
        }
      } else {
        alert(updateRes?.message || "更新失败，请重试");
      }
    } else {
      // 匿名用户：直接重新排盘，后端会更新备份
      const paipanRes = await post_paipan({ ...personInfo, update_id: person.id });
      if (paipanRes) {
        const records = JSON.parse(localStorage.getItem("bazi_anonymous_records") || "[]");
        const idx = records.findIndex((r) => r.id === person.id);
        if (idx >= 0) {
          records[idx] = {
            ...records[idx],
            name: personInfo.name,
            gender: personInfo.gender,
            birthday_str: personInfo.birthday_str,
            use_zaozi: personInfo.use_zaozi,
            use_true_solar: personInfo.use_true_solar,
            longitude: personInfo.longitude,
            birthplace: personInfo.birthplace,
            computed_at: new Date().toISOString(),
            nian_gan: paipanRes.nian_gan,
            nian_zhi: paipanRes.nian_zhi,
            yue_gan: paipanRes.yue_gan,
            yue_zhi: paipanRes.yue_zhi,
            ri_gan: paipanRes.ri_gan,
            ri_zhi: paipanRes.ri_zhi,
            shi_gan: paipanRes.shi_gan,
            shi_zhi: paipanRes.shi_zhi,
            result: paipanRes,
          };
          localStorage.setItem("bazi_anonymous_records", JSON.stringify(records));
        }
        onSaved();
        onClose();
      }
    }

    setSaving(false);
  }

  const closeIcon = fullScreen ? <ArrowBackIcon /> : <CloseIcon />;

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ p: 0 }}>
        <PageHeader
          title="编辑人物资料"
          leftAction={
            <IconButton
              size="small"
              onClick={onClose}
              disabled={saving}
              edge="start"
            >
              {closeIcon}
            </IconButton>
          }
        />
      </DialogTitle>
      <DialogContent dividers sx={{ px: 2, py: 0 }}>
        <PersonInfoInput
          defaultValues={person}
          onPaiPan={handleSubmit}
          submitLabel={saving ? "保存中..." : "保存"}
          hideHeader={true}
        />
      </DialogContent>
    </Dialog>
  );
}
